import styled from 'styled-components';

export const CouponGenerateWrapStyle = styled.div`
  position: relative;
  padding: 0 0 25px;

  .control-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    .btn-group {
      button + button {
        margin-left: 10px;
      }
    }
  }

  & > div:not(.coupon-generate-navbar) {
    background: white;
    margin-bottom: 10px;
  }

  .coupon-generate-coupon-list,
  .coupon-generate-user-list,
  .coupon-generate-selected-user-list {
    padding: 20px 20px;
  }

  .control-list,
  .coupon-generate-user-list {
    .info {
      font-weight: bold;
    }
  }
`;
